import {
    GET_ALLOCATION_STATUS,
    GET_ALLOCATION_CHALLAN,
    SEARCH_VENDOR_CHALLAN,
    EDIT_VENDOR_CHALLAN,
    DOWNLOAD_CHALLAN_DATA,
    RELEASE_ALLOCATION_CHALLAN,
    AUTOMATE_ALLOCATE,
    ALLOCATE_PRIOR_CHALLAN,
    DELETE_CHALLAN
} from '../endpoints/apiEndpoints'
import {
    buildRequestHeader,
    handleErrorResponse,
    handleRequestFailure,
    handleSuccessResponse,
    urlBuilder,
} from './apiUtils'

export const getAllocationStatus = async () => {
    const url = urlBuilder(GET_ALLOCATION_STATUS)
    const requestHeader = buildRequestHeader('GET')
    try {
        const response = await fetch(url, requestHeader)
        if (!response.ok) return await handleRequestFailure(response)
        else return await handleSuccessResponse(response)
    } catch (error) {
        return handleErrorResponse(error)
    }
}


export const searchVendorChallanList = async (payload, tanUuid) => {
    const url = urlBuilder(SEARCH_VENDOR_CHALLAN, { tanUuid })
    const requestHeader = buildRequestHeader('POST', payload)
    try {
        const response = await fetch(url, requestHeader)
        if (!response.ok) return await handleRequestFailure(response)
        else return await handleSuccessResponse(response)
    } catch (error) {
        return handleErrorResponse(error)
    }
}

export const getChallanAllocation = async () => {
    const url = urlBuilder(GET_ALLOCATION_CHALLAN)
    const requestHeader = buildRequestHeader('GET')
    try {
        const response = await fetch(url, requestHeader)
        if (!response.ok) return await handleRequestFailure(response)
        else return await handleSuccessResponse(response)
    } catch (error) {
        return handleErrorResponse(error)
    }
}

export const editVendorChallanDetails = async (payload) => {
    const url = urlBuilder(EDIT_VENDOR_CHALLAN)
    const requestHeader = buildRequestHeader('POST', payload)
    try {
        const response = await fetch(url, requestHeader)
        if (!response.ok) return await handleRequestFailure(response)
        else return await handleSuccessResponse(response)
    } catch (error) {
        return handleErrorResponse(error)
    }
}

export const downloadVendorChallan = async (payload, tanUuid) => {
    const url = urlBuilder(DOWNLOAD_CHALLAN_DATA, { tanUuid })
    const requestHeader = buildRequestHeader('POST', payload)
    try {
        const response = await fetch(url, requestHeader)
        if (!response.ok) return await handleRequestFailure(response)
        else return await handleSuccessResponse(response)
    } catch (error) {
        return handleErrorResponse(error)
    }
}


export const releaseAllocatedChallan = async (payload) => {
    const url = urlBuilder(RELEASE_ALLOCATION_CHALLAN)
    const requestHeader = buildRequestHeader('POST', payload)
    try {
        const response = await fetch(url, requestHeader)
        if (!response.ok) return await handleRequestFailure(response)
        else return await handleSuccessResponse(response)
    } catch (error) {
        return handleErrorResponse(error)
    }
}

export const challanAutomateAllocation = async (payload) => {
    const url = urlBuilder(AUTOMATE_ALLOCATE)
    const requestHeader = buildRequestHeader('POST', payload)
    try {
        const response = await fetch(url, requestHeader)
        if (!response.ok) return await handleRequestFailure(response)
        else return await handleSuccessResponse(response)
    } catch (error) {
        return handleErrorResponse(error)
    }
}

export const deleteChallanData = async (payload) => {
    const url = urlBuilder(DELETE_CHALLAN)
    const requestHeader = buildRequestHeader('POST', payload)
    try {
        const response = await fetch(url, requestHeader)
        if (!response.ok) return await handleRequestFailure(response)
        else return await handleSuccessResponse(response)
    } catch (error) {
        return handleErrorResponse(error)
    }
}

export const getAllocatePriorChallanStatus = async (payload,tanUuid,finacialYear) => {
    const url = urlBuilder(ALLOCATE_PRIOR_CHALLAN,{tanUuid,finacialYear})
    const requestHeader = buildRequestHeader('POST', payload)
    try {
        const response = await fetch(url, requestHeader)
        if (!response.ok) return await handleRequestFailure(response)
        else return await handleSuccessResponse(response)
    } catch (error) {
        return handleErrorResponse(error)
    }
}